<template>
  <div>
    <!-- The dynamic list title that comes in as a prop -->
    <div class="majorTitle">
      {{ listTitle }}
    </div>

    <div
      v-if="isLoading"
      class="loading-container marginNormalTop"
    >
      <div>
        <i class="fa fa-spinner fa-spin fa-2x fa-fw" />
        <span class="sr-only">Loading...</span>
        <div>Loading...</div>
      </div>
    </div>

    <!-- Loop through the lists of grouped invoices -->
    <div
      v-for="group in groupedOrders"
      v-else
      :key="group.title"
    >
      <!-- The title for this group of invoices -->
      <div class="minorTitle">
        {{ group.title }}
      </div>

      <!-- The list of items -->
      <ul v-if="group.orders.length > 0">
        <!-- Show the first order -->
        <li
          v-for="order in group.orders"
          :id="'item-card-' + order.id"
          :key="order.id"
          class="itemRow"
        >
          <ConsignmentOrder :co="order" />
        </li>
      </ul>

      <!-- There are no invoices in this list -->
      <div
        v-else
        class="colorGrey textCenter"
      >
        No auction inventory.
      </div>
    </div>

    <!-- The interset observer that fires when it enters the viewport -->
    <Observer @intersect="onIntersect" />
  </div>
</template>

<script>
import Observer from '../components/Observer.vue'
import ConsignmentOrder from './Cards/ConsignmentOrder.vue'

export default {

	name: 'ConsignmentList',

	components: {
		Observer,
		ConsignmentOrder
	},

	props: [
		'listTitle'
	],

	data () {
		return {
			'page': 0,
			'offset': 50
		}
	},

	computed: {
		/**
		 * List of customer consignment orders.
		 *
		 * @public
		 */
		consignmentOrders: function () {
			return this.$store.state.customerCos.objects || []
		},
		/**
		 * Whether an api call to get our consignment orders is in progress
		 *
		 * @public
		 */
		isLoading: function () {
			return this.$store.state.customerCos.isLoading
		},
		groupedOrders () {
			const soldGroup = {
				title: 'Past Auctions',
				orders: []
			}
			const sellingNowGroup = {
				title: 'Current Auctions',
				orders: []
			}
			for (const orderGroup of Object.values(this.consignmentOrders)) {
				if (orderGroup.group === 'SOLD') {
					if (orderGroup.orders.length > 0) {
						// We want to use the total inventory for the order group
						orderGroup.orders[0].inventory_count = orderGroup.total_inventory_count
						soldGroup.orders.push(orderGroup.orders[0])
					}
					continue
				}
				if (orderGroup.orders.length > 0) {
					// We want to use the total inventory for the order group
					orderGroup.orders[0].inventory_count = orderGroup.total_inventory_count
					sellingNowGroup.orders.push(orderGroup.orders[0])
				}
			}
			const groupedOrders = [sellingNowGroup, soldGroup]
			return groupedOrders
		}
	},

	mounted () {
		this.fetchConsignmentOrders()
	},
	methods: {
		fetchConsignmentOrders () {
			this.$store.dispatch('getCos')
		},
		/**
		 * Paginates list for the scroll Observer
		 */
		onIntersect () {
			this.page = this.page + 1
		}
	}
}

</script>

<style scoped></style>
